var _defs, _rect, _rect2, _rect3, _g, _path, _path2, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolflareHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#1b5a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a6f5e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1240 140) rotate(132) scale(420 360)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dbff6d",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dbff6d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260 760) rotate(-28) scale(520 420)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ff0c0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7ff0c0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "line",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ff0c0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#7ff0c0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7ff0c0",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#glow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#glow2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 220C280 150 440 150 600 220",
    stroke: "url(#line)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 360C290 280 480 280 680 360",
    stroke: "url(#line)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 500C340 420 540 420 740 500",
    stroke: "url(#line)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 200,
    r: 5,
    fill: "#7ff0c0",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 185,
    r: 5,
    fill: "#dbff6d",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 330,
    r: 5,
    fill: "#7ff0c0",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 315,
    r: 5,
    fill: "#dbff6d",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 480,
    r: 5,
    fill: "#7ff0c0",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 465,
    r: 5,
    fill: "#dbff6d",
    opacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 620C220 560 420 560 600 600C760 636 920 700 1120 710C1320 720 1480 670 1600 620V900H0V620Z",
    fill: "#0a2e27",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 520C240 470 450 470 640 510C810 546 980 610 1180 620C1360 629 1500 590 1600 550V900H0V520Z",
    fill: "#0c362e",
    opacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1040 320C1040 274 1078 236 1124 236H1338C1384 236 1422 274 1422 320V460C1422 506 1384 544 1338 544H1124C1078 544 1040 506 1040 460V320Z",
    stroke: "#dbff6d",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 310H1328C1350 310 1368 328 1368 350V420C1368 442 1350 460 1328 460H1090C1068 460 1050 442 1050 420V350C1050 328 1068 310 1090 310Z",
    fill: "#102f2a",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1285,
    cy: 385,
    r: 7,
    fill: "#dbff6d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1245,
    cy: 385,
    r: 7,
    fill: "#7ff0c0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098,
    y: 350,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#1f5b4b",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098,
    y: 372,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#1f5b4b",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098,
    y: 394,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#1f5b4b",
    opacity: 0.65
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210 620C1210 598 1228 580 1250 580H1352C1374 580 1392 598 1392 620V676C1392 721 1350 754 1301 770C1252 754 1210 721 1210 676V620Z",
    fill: "#102f2a",
    stroke: "#dbff6d",
    strokeOpacity: 0.6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288 655L1301 668L1326 642",
    stroke: "#dbff6d",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "end"
  }, /*#__PURE__*/React.createElement("text", {
    x: 1500,
    y: 250,
    fontSize: 16,
    letterSpacing: "0.3em",
    fill: "#dbff6d"
  }, "SOLANA WALLET GUIDE"), /*#__PURE__*/React.createElement("text", {
    x: 1500,
    y: 280,
    fontSize: 14,
    letterSpacing: "0.35em",
    fill: "#7ff0c0"
  }, "SECURITY  STAKING  SETUP"), /*#__PURE__*/React.createElement("text", {
    x: 1500,
    y: 310,
    fontSize: 12,
    letterSpacing: "0.4em",
    fill: "#dbff6d"
  }, "2026"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolflareHero);
export default __webpack_public_path__ + "static/media/solflare-hero.864b068e290ce397ea7e636267549d31.svg";
export { ForwardRef as ReactComponent };